var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"classic-view\"><div id=\"content\"><builder url=\"url\" id=\"id\" on-save=\"onSave\" hostname=\"HOSTNAME\"></builder></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/applications/customize/customize.jade
// module id = 1045
// module chunks = 0